import { ProgressBar } from "../components/progressBar";
import { ProgressHeaderWithPopup } from "../components/progressHeaderWithPopup";
import { HeadLogo } from "../components/headLogo";
import { LocationImageDisplay } from "../components/locationImageDisplay";

function ModeSelectionChoiceView({
  timeProgress,
  spaceProgress,
  handleModeClickACB,
  locTitle,
  imageKey,
}) {
  return (
    <div>
      <HeadLogo />
      <ProgressHeaderWithPopup currentStep={2} title={locTitle} />
      <div className="modeSelection-quest">
        <div id="modeSelection-title" className="modeSelection-title">
          Let’s do the....
        </div>
        <button
          id="modeSelection-time"
          className="modeSelection-modeBtn"
          onClick={() => handleModeClickACB("time")}
        >
          <div className="modeSelection-modeTitle">Time travel</div>
          <ProgressBar progress={timeProgress} type="time" />
        </button>
        <button
          id="modeSelection-space"
          className="modeSelection-modeBtn"
          onClick={() => handleModeClickACB("space")}
        >
          <div className="modeSelection-modeTitle">Space travel</div>
          <ProgressBar progress={spaceProgress} type="space" />
        </button>
      </div>
      <LocationImageDisplay imageKey={imageKey} dynamicHeight="50vh" />
    </div>
  );
}

export { ModeSelectionChoiceView };
